import React, { useState, useEffect } from 'react';
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme as useAppTheme } from 'context/ThemeContext';
import { useApi } from 'context/ApiProvider';
import { useDesignStore } from 'context/DesignContext';
import { GetBonesFromFolders } from 'services/WBCTService';


interface LoadWBCTPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

const LoadWBCTPanel: React.FC<LoadWBCTPanelProps> = ({ isOpen, onClose }) => {
  const { isDarkMode } = useAppTheme();
  const api = useApi();
  const [isLoading, setIsLoading] = useState(false);

  
  const handleClose = () => {
    onClose();
  };

  const openDesktopApp = async () => {
    // const token = encodeURIComponent(localStorage.getItem("accessToken")!);
    // const designId = useSelectedDesignStore.getState().designId;

    // const url =
    //   `myapp://run?designId=${designId}&token=${token}`

    // window.location.href = url
    
    setIsLoading(true);
    try {
      const currentDesign = useDesignStore.getState().insoleDesign;
      await GetBonesFromFolders("All", currentDesign);
      document.dispatchEvent(new CustomEvent('newWBCTScan', { detail: { status: true } }));
    } finally {
      setIsLoading(false);
      handleClose();
    }
  };

  useEffect(() => {
    if (!isOpen) return;

    // const BASE_API_URL: string = process.env.REACT_APP_API_URL!;
    //   const connection = new HubConnectionBuilder()
    //     .withUrl("http://localhost:5257/wbctHub", {
    //       withCredentials: true
    //     })
    //     .build();

    //   const currentDesignId = useSelectedDesignStore.getState().designId;
    //   connection.on("CalculationFinished", function (designId: number) {
    //     if (currentDesignId === designId){
    //       console.log("Calculation finished for design:", designId);
    //       alert("Calculation completed!");
    //     }
    //   });

    //   connection.start();

    //   return () => {
    //   connection.stop();
    // };

  }, [isOpen, api]);

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="load-template-title" closeAfterTransition sx={{ display: "flex", alignItems: "center", justifyContent: "center", }}>
      <Box
        sx={{
          bgcolor: isDarkMode ? '#333' : '#fff',
          color: isDarkMode ? '#fff' : '#000',
          borderRadius: 2,
          width: { xs: '95vw', md: '40vw' },
          maxHeight: { xs: '95vh', md: '80vh' },
          mx: 'auto',
          boxShadow: 24,
          outline: 'none',
          display: 'flex',
          flexDirection: 'column',
          p: 0,
          position: 'relative',
        }}
      >
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2, borderBottom: '1px solid #ccc' }}>
          <Typography variant="h6" sx={{ color: isDarkMode ? '#fff' : '#076596' }}>
            WBCT Panel
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon sx={{ color: isDarkMode ? '#fff' : '#000' }} />
          </IconButton>
        </Box>

        {/* Content */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            p: 3,
            position: 'relative',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              textAlign: 'start',
              color: '#999',
              fontStyle: 'italic',
            }}
          >
            Press the "Load" button to load the bone models from desktop app. 
            <br/>
            The process will take up to several minutes, please be patient.
          </Typography>
        </Box>

        {/* Footer */}
        <Box sx={{ p: 2, borderTop: '1px solid #ccc', display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{
              color: isDarkMode ? '#fff' : '#000',
              borderColor: '#aaa',
              width: '80px',
              fontWeight: 500,
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              color: '#fff',
              borderColor: '#aaa',
              backgroundColor: '#076596',
              width: '80px',
              fontWeight: 500,
              px: 4,
              '&:hover': { backgroundColor: '#0a6fb4' }
            }}
            onClick={() => openDesktopApp()}
          >
            Load
          </Button>
        </Box>

        {/* Loading Indicator */}
        {isLoading && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              bgcolor: 'rgba(212, 212, 212, 0.47)',
              zIndex: 50,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 2,
            }}
          >
            <CircularProgress sx={{ color: '#076596' }} />
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default LoadWBCTPanel;
